import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import Fonts from '../../../../ui/global/Fonts';
import Icon from '../../../../ui/global/Icon';

const RepoContainer = styled.div<{ $isButton: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 100%;
    font-family: ${Fonts.lexendSemiLight.fontFamily};
    font-weight: ${Fonts.lexendSemiLight.fontWeight};
    font-size: 14px;
    line-height: 1.2em;
    color: ${Colors.grey2};
    gap: 5px;
    ${props => props.$isButton && `
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    `}
`;

interface GithubRepoProps {
    repoName: string;
    isButton?: boolean;
    repoUrl?: string;
}

const GithubRepo: FunctionComponent<GithubRepoProps> = ({ repoName, isButton, repoUrl }) => {
    const handleClick = () => {
        if (isButton && repoUrl) {
            window.open(repoUrl, '_blank');
        }
    };

    return (
        <RepoContainer $isButton={isButton} onClick={handleClick}>
            <span>{repoName}</span>
            {isButton && (
                <Icon icon='arrow-up-right-diagonal' color={Colors.grey2} size={17} />
            )}
        </RepoContainer>
    );
};

export default GithubRepo;